import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { LABELS } from "@shared/constants";
import { Department, JobLevel, PaginatedResponse } from "@shared/models";
import { Observable, of, tap } from "rxjs";
import { ToHttpHeadersService } from "../utils";

@Injectable({
	providedIn: 'root'
})
export class ReportService {

	readonly url = `/api/v1/report`;
	readonly hrUrl = `/api/v1/records`;
    readonly http = inject(HttpClient);
    readonly toHttpHeaders = inject(ToHttpHeadersService);
    readonly label = LABELS.SSS_CONFIGURATION;

    generateMonthlySalary(params: { payoutDate1: Date | null, payoutDate2: Date | null, jobLevel?: string }) {
        const body = {
            payoutDate: [params.payoutDate1?.toISOString(), params.payoutDate2?.toISOString()].filter(Boolean),
            jobLevel: [params.jobLevel]
        };

        return this.http.post(`${this.url}/csv/payroll-process`, body, {
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            tap(response => {
            const disposition = response.headers.get('Content-Disposition');
            const filename = disposition
                ? disposition.split('filename=')[1].replace(/"/g, '')
                : 'payroll_report.csv';

            const blob = new Blob([response.body!], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(url);
            })
        );
    }
    
    generateMonthlyContribution(params: { payoutDate1: Date | null, payoutDate2: Date | null, contributionType?: string}) {
      const body = {
            payoutDate: [params.payoutDate1?.toISOString(), params.payoutDate2?.toISOString()].filter(Boolean),
            contributionType: params.contributionType
        };

        return this.http.post(`${this.url}/csv/govt-contrib-report`, body, {
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            tap(response => {
            const disposition = response.headers.get('Content-Disposition');
            const filename = disposition
                ? disposition.split('filename=')[1].replace(/"/g, '')
                : 'contribution_report.csv';

            const blob = new Blob([response.body!], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(url);
            })
        );
    }
   
    generatePayrollBankFile(params: { payoutDate1: Date | null, payoutDate2: Date | null, department?: string }) {
        const body = {
            payoutDate: [params.payoutDate1?.toISOString(), params.payoutDate2?.toISOString()].filter(Boolean),
            department: params.department
        };

        return this.http.post(`${this.url}/csv/payroll-bank-file`, body, {
            responseType: 'blob',
            observe: 'response'
        }).pipe(
            tap(response => {
            const disposition = response.headers.get('Content-Disposition');
            const filename = disposition
                ? disposition.split('filename=')[1].replace(/"/g, '')
                : 'payroll_report.csv';

            const blob = new Blob([response.body!], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            URL.revokeObjectURL(url);
            })
        );
    }

    listJobLevel(params?: any): Observable<PaginatedResponse<JobLevel>> {
        return this.http.get<PaginatedResponse<JobLevel>>(`${this.hrUrl}/job-level`, { params });
    }

    listDepartment(params?: any): Observable<PaginatedResponse<Department>> {
        return this.http.get<PaginatedResponse<Department>>(`${this.hrUrl}/department`, { params });
    }

    // listBenefit(params?: any): Observable<PaginatedResponse<Benefit>> {
    //     return this.http.get<PaginatedResponse<Benefit>>(`${this.hrUrl}/benefit`, { params });
    // }

}